export default {
  PRODUCTION: {
    OANDA: "https://www.oanda.com/eu-{lang}/onboarding",
    PL: "https://www.tms.pl/onboarding/",
    OTHER: "https://www.tmsbrokers.com/{lang}/onboarding",
  },
  STAGE: {
    OANDA: "https://www-stg.stage.oanda.com/eu-{lang}/onboarding",
    PL: "https://master-onboardingprod.test.tms.pl/onboarding/",
    OTHER: "https://master-onboardingprod.test.tms.pl/{lang}/onboarding/",
  },
  DEVELOPMENT: {
    OANDA: "https://$CI_COMMIT_REF_NAME-onboardingoanda.test.tms.pl/eu-{lang}/",
    PL: "https://$CI_COMMIT_REF_NAME-onboarding.test.tms.pl/",
    OTHER: "https://$CI_COMMIT_REF_NAME-onboarding.test.tms.pl/{lang}/",
  },
  LOCAL: {
    OANDA: "http://localhost:8080/eu-{lang}/",
    PL: "http://localhost:8080",
    OTHER: "http://localhost:8080/{lang}/",
  }
};